export function GetMissingDataDisplay(cardCaption: string, supportQuestion: string | JSX.Element) {
  return (
    <section className="missing-data-details">
      <p className="missing-data-warn">{cardCaption}</p>
      <div className="missing-data-support">{supportQuestion}</div>
    </section>
  );
}
